import { baseUrl } from "../lib/helper"
import { getToken } from "../providers/implicitGrantProvider"

export interface QuestionnaireCampaign {
	id: string
	total: number
	queued: number
	submittedToEmail: number
	failed: number
	verified: number
	registered?: number
	completed?: number
}
export interface QuestionnairePreflight {
	employeeCount: number
	blockers: { id: string; name: string; reason: string }[]
	fingerprint: string
	canSend: boolean
	censusChanged: boolean
	dispatchLimitExceeded: boolean
	campaign: QuestionnaireCampaign | null
}
export interface QuestionnaireInvitation {
	emailHint: string
	expiresAt: string
	verified: boolean
	collectionEnabled: boolean
}

export type QuestionnaireAccountHandoff = { registered: true; signInUrl: string; message: string } | { registered: false; registrationUrl: string; message: string }

export async function medicalRequest<T>(path: string, body?: unknown, authenticated = true, signal?: AbortSignal, method?: "PUT"): Promise<T> {
	const headers: Record<string, string> = { Accept: "application/json", "Content-Type": "application/json" }
	if (authenticated) {
		const token = await getToken()
		if (!token || token === "crm_web_resource_context") throw new Error("Sign in to the sandbox portal to manage medical questionnaires.")
		headers.Authorization = `Bearer ${token}`
	}
	const response = await fetch(`${baseUrl}/_api/medical-questionnaire/${path}`, {
		method: method || (body === undefined ? "GET" : "POST"),
		headers,
		cache: "no-store",
		credentials: "omit",
		signal,
		body: body === undefined ? undefined : JSON.stringify(body)
	})
	const data = await response.json()
	if (!response.ok) throw new Error(typeof data.error === "string" ? data.error : "The medical questionnaire service is unavailable.")
	return data
}
